import { FC } from 'react'
import { InputStyled } from './styled-components'
import { IProps } from './types'

const InputComponent: FC<IProps> = (props) => <InputStyled {...props} />

export default InputComponent